import React from "react";
import { useTranslation } from "react-i18next";

export default function DossierEmptyState({ className = "" }) {
  const { t } = useTranslation();

  return (
    <section
      className={`rounded-3xl border border-emerald-100 bg-white/85 p-6 sm:p-8 text-center shadow-sm ${className}`}
    >
      <h2 className="text-2xl font-bold text-gray-900">
        {t("ui.dossier.modes.express", "LivingSoils Express")}
      </h2>
      <p className="mt-3 text-sm sm:text-base text-gray-600">
        {t(
          "ui.dossier.empty.express",
          "Els materials de LivingSoils Express estaran disponibles properament."
        )}
      </p>
    </section>
  );
}
